var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pwd-body" }, [
    _c("div", { staticClass: "pwd-wrapper" }, [
      _c("div", { staticClass: "pwd-content" }, [
        _c("div", { staticClass: "span-header" }, [
          _c("div", { staticClass: "bi-text" }, [
            _c("span", { staticStyle: { "text-align": "center" } }, [
              _vm._v(_vm._s(_vm.$t("pblink.key_pwd")) + "\n          "),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "input-layout" }, [
          _c("div", { staticClass: "input-main" }, [
            _c(
              "div",
              { staticClass: "div-input" },
              [
                _c(
                  "el-form",
                  {
                    ref: "pwdForm",
                    attrs: { model: _vm.form, rules: _vm.rule, size: "small" },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "password" } },
                      [
                        _c("el-input", {
                          staticClass: "real-input",
                          attrs: {
                            maxlength: "4",
                            "show-password": "",
                            placeholder: _vm.$t("pblink.input_placeholder"),
                          },
                          model: {
                            value: _vm.form.password,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "password", $$v)
                            },
                            expression: "form.password",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "abs-input" }, [
            _c("div", { staticClass: "input-text" }, [_vm._v(_vm._s(_vm.msg))]),
          ]),
        ]),
        _c("div", { staticClass: "auth-root-class" }, [
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.refresh },
                },
                [_vm._v(_vm._s(_vm.$t("pblink.sure_bt")))]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }